import { IAssessmentState, statePropName } from './slice';
import { EAssessmentSubpage } from './types';

export interface IAppState {
  // this feature state
  [statePropName]: IAssessmentState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getAssessmentState = (state: IAppState) => state[statePropName];

export const isAssessmentStarted = (state: IAppState) => getAssessmentState(state).started;

export const getCurrentSubpage = (state: IAppState) => getAssessmentState(state).subpage;

export const isSessionSubpage = (state: IAppState) => getAssessmentState(state).subpage === EAssessmentSubpage.Session;

export const getWorkoutIndex = (state: IAppState) => getAssessmentState(state).index;

export const isUnityReady = (state: IAppState) => getAssessmentState(state).unityStatus;

export const getExerciseId = (state: IAppState) => getAssessmentState(state).exerciseId;

export const isRunning = (state: IAppState) => getAssessmentState(state).running;

export const getWorkoutId = (state: IAppState) => getAssessmentState(state).workoutId;

export const getDomains = (state: IAppState) => getAssessmentState(state).domains;

export const isCFQStarted = (state: IAppState) => getAssessmentState(state).cfqStarted;

export const getSavingState = (state: IAppState) => getAssessmentState(state).saving;
